import { useRoomStore } from '@features/room';
import { Panel } from '@shared/ui';

export function RoomSettingsPanel() {
  const settings = useRoomStore((s) => s.settings);
  const updateSettings = useRoomStore((s) => s.updateSettings);
  const connectionState = useRoomStore((s) => s.connectionState);
  const disabled = connectionState === 'connected' || connectionState === 'connecting';

  return (
    <Panel title="ROOM SETTINGS">
      <div className="space-y-4">
        <SettingField
          label="Display name"
          value={settings.participantName}
          placeholder="Your name"
          disabled={disabled}
          onChange={(v) => updateSettings({ participantName: v })}
        />
      </div>

      {disabled && (
        <p className="mt-4 text-xs text-text-muted">Leave the room to change your display name.</p>
      )}
    </Panel>
  );
}

function SettingField({
  label,
  value,
  placeholder,
  disabled,
  onChange,
}: {
  label: string;
  value: string;
  placeholder: string;
  disabled: boolean;
  onChange: (v: string) => void;
}) {
  return (
    <div>
      <label className="mb-1.5 block text-xs font-medium text-text-secondary">{label}</label>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-surface-border bg-surface-2 px-3 py-2 text-sm text-text-primary placeholder-text-muted outline-none focus:border-accent disabled:cursor-not-allowed disabled:opacity-50"
      />
    </div>
  );
}